module.exports = __webpack_public_path__ + "img/f51a589.jpg";